import { Image, List } from "antd";
import caricatureBaham from "../../assets/images/caricature-baham-don-ataajy.png";
import remerciementBayangam from "../../assets/images/remerciement-bayangam.png";
import BlockHeader from "../BlockHeader";

type HomePageNews = {
  img: {
    alt: string;
    src: string;
  };
  title: string;
  teaser: string;
};

const newsList: HomePageNews[] = [
  {
    img: {
      alt: "Remerciements de l'inspecteur d'arrondissement de l'éducationn de base de Bayangam aux membres du groupe Ataajy",
      src: remerciementBayangam,
    },
    teaser:
      "Remerciements de l'inspecteur d'arrondissement de l'éducation de base de Bayangam",
    title: "Balançoire de l'école maternelle de Bayangam",
  },
  {
    img: {
      alt: "Le président avec un pack de jus",
      src: caricatureBaham,
    },
    teaser:
      "Une nouvelle mission humanitaire a été effectuée pendant ce mois de Février 2021 au Cameroun ...",
    title: "Voyage Humanitaire – Février 2021",
  },
];

const BlockNews = () => (
  <div className="block-news">
    <div className="text-center">
      <BlockHeader preTitle="Blog" title="Notre actualité" />
    </div>
    <List
      itemLayout="vertical"
      size="large"
      dataSource={newsList}
      renderItem={(item) => (
        <List.Item
          extra={<Image src={item.img.src} alt={item.img.alt} height={150} />}
        >
          <List.Item.Meta description={item.title} />
          {item.teaser}
        </List.Item>
      )}
    />
  </div>
);

export default BlockNews;
